import { transformSearchPersonToMaritalFormValues } from '../../../arc/features/person-search/oscrr-helpers';
import { SearchPerson } from '../../../arc/features/person-search/person-search-model';

export function MapSearchPersonToReivewRenderModel(searchPerson: SearchPerson){
	return transformSearchPersonToMaritalFormValues(searchPerson, '');
}